import {
  CLEAR_CHILDREN_DETAIL,
  SET_CHILDREN_DETAIL,
  SET_LIST_DATES_HAS_EVALUATION,
  SET_LIST_DATES_HAS_VIDEO,
  SET_LIST_VIDEO,
  SET_CREATE_REPORT_DATA,
} from 'store/types/children';

const initialState = {
  childrenDetail: {},
  listVideo: [],
  listDatesHasVideo: [],
  listDatesHasEvaluation: [],
  createReportData: {
    reportId: null,
    evaluationId: null,
  },
};

const childrenReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHILDREN_DETAIL:
      return {
        ...state,
        childrenDetail: action?.payload,
      };
    case SET_LIST_VIDEO:
      return {
        ...state,
        listVideo: action?.payload,
      };
    case SET_LIST_DATES_HAS_VIDEO:
      return {
        ...state,
        listDatesHasVideo: action?.payload,
      };
    case SET_LIST_DATES_HAS_EVALUATION:
      return {
        ...state,
        listDatesHasEvaluation: action?.payload,
      };
    case SET_CREATE_REPORT_DATA:
      return {
        ...state,
        createReportData: action?.payload,
      };
    case CLEAR_CHILDREN_DETAIL:
      return {
        ...state,
        childrenDetail: initialState.childrenDetail,
        listVideo: initialState.listVideo,
        listDatesHasVideo: initialState.listDatesHasVideo,
        listDatesHasEvaluation: initialState.listDatesHasEvaluation,
        createReportData: initialState.createReportData,
      };
    default:
      return state;
  }
};

export default childrenReducer;
